import '../../custom/js/index';
import '../../custom/js/deferred';

// Base SCSS
import '../../custom/scss/base.scss';
import '../../custom/scss/pages/dairy-does-more-landing.scss';
import '../../custom/scss/pages/interactions.scss';

// Components SCSS
import '../../custom/scss/components/recipes/recipes-section.scss';

(function initDairyDoesMore() {
    if (!window.jQuery || !jQuery.fn || !jQuery.fn.slick) {
        return;
    }

    const $track = jQuery('#carouselTrack');
    const $prevBtn = jQuery('#prevBtn');
    const $nextBtn = jQuery('#nextBtn');
    const progressFill = document.getElementById('progressFill');

    const $reasonsTrack = jQuery('#reasonsCarouselTrack');
    const $reasonsPrevBtn = jQuery('#reasonsPrevBtn');
    const $reasonsNextBtn = jQuery('#reasonsNextBtn');
    const reasonsProgressFill = document.getElementById('reasonsProgressFill');
    
    
    const $recipeItemTemplate = jQuery('#recipeItemTemplate');
    const $recipeTrack = jQuery('#recipeCarouselTrack');
    const $recipePrevBtn = jQuery('#recipePrevBtn');
    const $recipeNextBtn = jQuery('#recipeNextBtn');
    const recipeProgressFill = document.getElementById('recipeProgressFill');

    const heroPlayBtn = document.querySelector('.hero .play-cta');

    const modal = document.getElementById('videoModal');
    const video = document.getElementById('videoPlayer');
    const closeBtn = document.getElementById('videoModalClose');
    const backdrop = modal ? modal.querySelector('[data-video-close]') : null;
    const viewport = document.querySelector('.carousel-viewport');

    const $recipesRadios = jQuery('.recipe-filter-radio');
    
    const $dataRef = $('#recipeItemData');
    const initData = JSON.parse($dataRef.text().replaceAll('&quot;', '"').replaceAll('\n', '').trim());
    $dataRef.remove();

    let dragStartX = 0;
    let dragStartY = 0;
    let dragged = false;

    function updateProgress(progressNode, currentIndex, slideCount) {
        if (!progressNode || !slideCount) {
            return;
        }
        const pct = ((currentIndex + 1) / slideCount) * 100;
        progressNode.style.width = `${pct}%`;
    }

    function runRecipeSlickSlider($track, totalSlides) {
        if ($track.length) {
            const slideToShowCount = ($(window).width() >= 998) ? 4 : 1;
            const slideToScroll = 1;
            const totalSlidesForSlick =  totalSlides - slideToShowCount + slideToScroll;

            $track.on('init', (_event, slick) => {
                updateProgress(recipeProgressFill, slick.currentSlide || 0, totalSlidesForSlick);
            });

            $track.on('beforeChange', (_event, slick, _currentSlide, nextSlide) => {
                updateProgress(recipeProgressFill, nextSlide, totalSlidesForSlick);
            });

            $track.on('afterChange', (_event, slick, currentSlide) => {
                updateProgress(recipeProgressFill, currentSlide, totalSlidesForSlick);
            });

            $track.slick({
                arrows: false,
                dots: false,
                infinite: false,
                draggable: true,
                swipe: true,
                touchMove: true,
                slidesToShow: slideToShowCount,
                slidesToScroll: slideToScroll,
                variableWidth: $(window).width() <= 998,
                speed: 320,
                adaptiveHeight: false
            });
        }
    }

    function setSlickPosition($slider) {
        if (!$slider.length || !$slider.hasClass('slick-initialized')) {
            return;
        }
        $slider.slick('setPosition');
    }

    function handleRenderItem(item) {
        const template = $recipeItemTemplate.text();
        return template
            .replaceAll('%card_url%', item.Url)
            .replaceAll('%card_img%', item.Image)
            .replaceAll('%card_img_alt%', item.ImageAltText)
            .replaceAll('%card_subtitle%', item.RecipeTypes[0].Text)
            .replaceAll('%card_title%', item.Title);
    }

    function renderRecipeItem(items) {
        if (items.length) {
            $recipeTrack.removeClass('slick-initialized').removeClass('slick-slider');
            const elementsToRender = items.map(handleRenderItem);
            $recipeTrack.html(elementsToRender.join(''));
            setSlickPosition($recipeTrack);
            runRecipeSlickSlider($recipeTrack, items.length);
        } 
    }

    function handleLoading(isLoading) {
        const $recipeCard = jQuery('.recipe-card');
        if (isLoading) {
            $recipeCard.addClass('is-loading');
        } else {
            $recipeCard.removeClass('loading');
        }
    }

    async function fetchRecipesItems(recipeType) {
        if (recipeType && recipeType !== 'All') {
            handleLoading(true);
            try {
                const url = `/api/recipe?RecipeType=${recipeType}&Sort=Newest&PageIndex=0&PageSize=8&IncludeDocumentForPath=false`;
                const response = await fetch(url);
                const data = await response.json();
                renderRecipeItem(data.Items);
            } catch (e) {
                renderRecipeItem(initData.Items);
            } finally {
                handleLoading(false);
            }
        } else {
            renderRecipeItem(initData.Items);
        }
    }
    
    function handleRecipeRadiosEvent() {
        fetchRecipesItems();
        $recipesRadios.on('change', (event) => {
            const selectedValue = event.target.value;
            fetchRecipesItems(selectedValue);
        });
    }


    function refreshCarouselLayout() {
        setSlickPosition($track);
        setSlickPosition($reasonsTrack);
        handleRecipeRadiosEvent();
    }

    function openVideo(src) {
        if (!modal || !video || !src) {
            return;
        }

        video.pause();
        video.src = src;
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';

        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => { });
        }
    }

    function closeVideo() {
        if (!modal || !video) {
            return;
        }

        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        video.pause();
        video.removeAttribute('src');
        video.load();
    }

    if ($track.length) {
        $track.on('init', (_event, slick) => {
            updateProgress(progressFill, slick.currentSlide || 0, slick.slideCount);
        });

        $track.on('beforeChange', (_event, slick, _currentSlide, nextSlide) => {
            updateProgress(progressFill, nextSlide, slick.slideCount);
        });

        $track.on('afterChange', (_event, slick, currentSlide) => {
            updateProgress(progressFill, currentSlide, slick.slideCount);
        });

        $track.slick({
            arrows: false,
            dots: false,
            infinite: false,
            draggable: true,
            swipe: true,
            touchMove: true,
            variableWidth: true,
            slidesToScroll: 1,
            speed: 320,
            adaptiveHeight: false
        });
    }

    if ($prevBtn.length && $track.length) {
        $prevBtn.on('click', () => {
            $track.slick('slickPrev');
        });
    }

    if ($nextBtn.length && $track.length) {
        $nextBtn.on('click', () => {
            $track.slick('slickNext');
        });
    }

    if ($reasonsTrack.length) {
        $reasonsTrack.on('init', (_event, slick) => {
            updateProgress(reasonsProgressFill, slick.currentSlide || 0, slick.slideCount);
        });

        $reasonsTrack.on('beforeChange', (_event, slick, _currentSlide, nextSlide) => {
            updateProgress(reasonsProgressFill, nextSlide, slick.slideCount);
        });

        $reasonsTrack.on('afterChange', (_event, slick, currentSlide) => {
            updateProgress(reasonsProgressFill, currentSlide, slick.slideCount);
        });

        $reasonsTrack.slick({
            arrows: false,
            dots: false,
            infinite: false,
            draggable: true,
            swipe: true,
            touchMove: true,
            variableWidth: true,
            slidesToScroll: 1,
            speed: 320,
            adaptiveHeight: false
        });
    }

    window.addEventListener('load', refreshCarouselLayout);

    let resizeFrame = null;
    window.addEventListener('resize', () => {
        if (resizeFrame) {
            window.cancelAnimationFrame(resizeFrame);
        }
        resizeFrame = window.requestAnimationFrame(() => {
            refreshCarouselLayout();
            resizeFrame = null;
        });
    });

    if ($recipePrevBtn.length && $recipeTrack.length) {
        $recipePrevBtn.on('click', () => {
            $recipeTrack.slick('slickPrev');
        });
    }

    if ($recipeNextBtn.length && $recipeTrack.length) {
        $recipeNextBtn.on('click', () => {
            $recipeTrack.slick('slickNext');
        });
    }

    if ($reasonsPrevBtn.length && $reasonsTrack.length) {
        $reasonsPrevBtn.on('click', () => {
            $reasonsTrack.slick('slickPrev');
        });
    }

    if ($reasonsNextBtn.length && $reasonsTrack.length) {
        $reasonsNextBtn.on('click', () => {
            $reasonsTrack.slick('slickNext');
        });
    }

    if (heroPlayBtn) {
        heroPlayBtn.addEventListener('click', () => {
            openVideo(heroPlayBtn.getAttribute('data-video-src'));
        });
    }

    if (viewport) {
        viewport.addEventListener('pointerdown', (event) => {
            dragged = false;
            dragStartX = event.clientX;
            dragStartY = event.clientY;
        });

        viewport.addEventListener('pointermove', (event) => {
            if (Math.abs(event.clientX - dragStartX) > 8 || Math.abs(event.clientY - dragStartY) > 8) {
                dragged = true;
            }
        });

        viewport.addEventListener('pointerup', () => {
            setTimeout(() => {
                dragged = false;
            }, 0);
        });
    }

    document.querySelectorAll('.slide-video-trigger').forEach((slide) => {
        slide.addEventListener('click', () => {
            if (dragged) {
                return;
            }
            const slickSlideEl = slide.closest('.slick-slide');
            if (slickSlideEl) {
                const targetIndex = Number(slickSlideEl.getAttribute('data-slick-index'));
                if (Number.isFinite(targetIndex)) {
                    const slickInstance = $track.slick('getSlick');
                    const current = slickInstance ? slickInstance.currentSlide : 0;
                    if (targetIndex !== current) {
                        $track.slick('slickGoTo', targetIndex);
                        return;
                    }
                }
            }
            openVideo(slide.getAttribute('data-video-src'));
        });

        slide.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                const slickSlideEl = slide.closest('.slick-slide');
                if (slickSlideEl) {
                    const targetIndex = Number(slickSlideEl.getAttribute('data-slick-index'));
                    if (Number.isFinite(targetIndex)) {
                        const slickInstance = $track.slick('getSlick');
                        const current = slickInstance ? slickInstance.currentSlide : 0;
                        if (targetIndex !== current) {
                            $track.slick('slickGoTo', targetIndex);
                            return;
                        }
                    }
                }
                openVideo(slide.getAttribute('data-video-src'));
            }
        });
    });

    if (closeBtn) {
        closeBtn.addEventListener('click', closeVideo);
    }

    if (backdrop) {
        backdrop.addEventListener('click', closeVideo);
    }

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && modal && modal.classList.contains('is-open')) {
            closeVideo();
        }
    });

    $('.variable-width').slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        centerMode: true,
        variableWidth: true
    });
}());
